import { UsersActionTypes, UsersActionsUnion } from '../actions/users.actions';
import { User } from '../../user';
import { orderByProperty } from 'src/app/shared/utils';
import { merge } from 'src/app/shared/utils';

export interface UsersState {
  users: any[] | null;
  selectedUser: User | null;
  loading: boolean;
  loaded: boolean;
  saving: boolean;
  error: any;
}

const initialState: UsersState = {
  users: null,
  selectedUser: null,
  loading: false,
  loaded: true,
  saving: false,
  error: null
};

export function reducer(
  state: UsersState = initialState,
  action: UsersActionsUnion
): UsersState {
  switch (action.type) {
    case UsersActionTypes.GetUsers:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case UsersActionTypes.GetUsersSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        users: orderByProperty([...action.payload], 'lastName')
      };

    case UsersActionTypes.GetUsersFailure:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };

    case UsersActionTypes.UpdateUser:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case UsersActionTypes.UpdateUserSuccess:
      const updatedUser = action.payload;
      
      let updatedUsers = state.users.map((user) => {
        if (updatedUser.id == user.id) {         
          return merge(user, updatedUser);          
        }

        return user;
      });

      return {
        ...state,
        users: updatedUsers,
        loading: false,
        loaded: true
      };

    case UsersActionTypes.UpdateUserFailure:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };

    case UsersActionTypes.AddUser:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case UsersActionTypes.AddUserSuccess:
      const newUser = action.payload;
      let usersList = [...state.users];   
      usersList.push(newUser);
      usersList = orderByProperty(usersList, 'lastName');

      return {
        ...state,
        users: usersList,
        loading: false,
        loaded: true
      };

    case UsersActionTypes.AddUserFailure:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };

    case UsersActionTypes.DeleteUser:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case UsersActionTypes.DeleteUserSuccess:
      const deactivatedUser = action.payload;
      let userList = [...state.users]
      userList.splice(
        userList.findIndex(i => {
          return i.id === deactivatedUser.id;
        }), 1);

      return {
        ...state,
        users:userList ,
        loading: false,
        loaded: true,
        selectedUser: action.payload
      };

    case UsersActionTypes.DeleteUserFailure:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };

    // default
    default:
      return state;
  }
}

export const getUsers = (state: UsersState) => state.users;

export const getUsersLoading = (state: UsersState) => state.loading;

export const getUsersError = (state: UsersState) => state.error;
